/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BulkProviderPostModel } from '../models';
// @ts-ignore
import type { BulkProviderPostResponseModel } from '../models';
// @ts-ignore
import type { GetProviders200Response } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { NpiRegistryData } from '../models';
// @ts-ignore
import type { ProviderExtendedResponseModel } from '../models';
// @ts-ignore
import type { ProviderPatchModel } from '../models';
// @ts-ignore
import type { ProviderPostModel } from '../models';
// @ts-ignore
import type { ProviderSearchModel } from '../models';
/**
 * ProvidersApi - axios parameter creator
 * @export
 */
export const ProvidersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API to delete/mark inactive
         * @summary delete a Provider
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProvider: async (providerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('deleteProvider', 'providerId', providerId)
            const localVarPath = `/api/v1/provider/{providerId}`
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to get Provider data
         * @summary get Provider
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProvider: async (providerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getProvider', 'providerId', providerId)
            const localVarPath = `/api/v1/provider/{providerId}`
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list Providers
         * @param {ProviderSearchModel} providerSearchModel 
         * @param {boolean} [allProviders] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviders: async (providerSearchModel: ProviderSearchModel, allProviders?: boolean, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerSearchModel' is not null or undefined
            assertParamExists('getProviders', 'providerSearchModel', providerSearchModel)
            const localVarPath = `/api/v1/provider/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (allProviders !== undefined) {
                localVarQueryParameter['allProviders'] = allProviders;
            }

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerSearchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ingest providers from NPIs
         * @param {BulkProviderPostModel} bulkProviderPostModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestProviders: async (bulkProviderPostModel: BulkProviderPostModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkProviderPostModel' is not null or undefined
            assertParamExists('ingestProviders', 'bulkProviderPostModel', bulkProviderPostModel)
            const localVarPath = `/api/v1/provider/ingest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkProviderPostModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to update status of Provider
         * @summary update Provider status
         * @param {string} providerId 
         * @param {ProviderPatchModel} providerPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchProvider: async (providerId: string, providerPatchModel: ProviderPatchModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('patchProvider', 'providerId', providerId)
            // verify required parameter 'providerPatchModel' is not null or undefined
            assertParamExists('patchProvider', 'providerPatchModel', providerPatchModel)
            const localVarPath = `/api/v1/provider/{providerId}`
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerPatchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to add a new Provider
         * @summary add a new Provider
         * @param {ProviderPostModel} providerPostModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postProvider: async (providerPostModel: ProviderPostModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerPostModel' is not null or undefined
            assertParamExists('postProvider', 'providerPostModel', providerPostModel)
            const localVarPath = `/api/v1/provider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerPostModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to validate the Provider
         * @summary validate Provider
         * @param {string} [npi] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProvider: async (npi?: string, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/provider/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (npi !== undefined) {
                localVarQueryParameter['npi'] = npi;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * verify NPI and fetch npi details from npi registry api
         * @summary verify npi details
         * @param {string} npi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyNpi: async (npi: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'npi' is not null or undefined
            assertParamExists('verifyNpi', 'npi', npi)
            const localVarPath = `/api/v1/provider/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (npi !== undefined) {
                localVarQueryParameter['npi'] = npi;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProvidersApi - functional programming interface
 * @export
 */
export const ProvidersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProvidersApiAxiosParamCreator(configuration)
    return {
        /**
         * API to delete/mark inactive
         * @summary delete a Provider
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProvider(providerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProvider(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProvidersApi.deleteProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to get Provider data
         * @summary get Provider
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProvider(providerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderExtendedResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProvider(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProvidersApi.getProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list Providers
         * @param {ProviderSearchModel} providerSearchModel 
         * @param {boolean} [allProviders] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviders(providerSearchModel: ProviderSearchModel, allProviders?: boolean, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProviders200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviders(providerSearchModel, allProviders, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProvidersApi.getProviders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ingest providers from NPIs
         * @param {BulkProviderPostModel} bulkProviderPostModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ingestProviders(bulkProviderPostModel: BulkProviderPostModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkProviderPostResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ingestProviders(bulkProviderPostModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProvidersApi.ingestProviders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to update status of Provider
         * @summary update Provider status
         * @param {string} providerId 
         * @param {ProviderPatchModel} providerPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchProvider(providerId: string, providerPatchModel: ProviderPatchModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchProvider(providerId, providerPatchModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProvidersApi.patchProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to add a new Provider
         * @summary add a new Provider
         * @param {ProviderPostModel} providerPostModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postProvider(providerPostModel: ProviderPostModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postProvider(providerPostModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProvidersApi.postProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to validate the Provider
         * @summary validate Provider
         * @param {string} [npi] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateProvider(npi?: string, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateProvider(npi, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProvidersApi.validateProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * verify NPI and fetch npi details from npi registry api
         * @summary verify npi details
         * @param {string} npi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyNpi(npi: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NpiRegistryData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyNpi(npi, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProvidersApi.verifyNpi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProvidersApi - factory interface
 * @export
 */
export const ProvidersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProvidersApiFp(configuration)
    return {
        /**
         * API to delete/mark inactive
         * @summary delete a Provider
         * @param {ProvidersApiDeleteProviderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProvider(requestParameters: ProvidersApiDeleteProviderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProvider(requestParameters.providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * API to get Provider data
         * @summary get Provider
         * @param {ProvidersApiGetProviderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProvider(requestParameters: ProvidersApiGetProviderRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProviderExtendedResponseModel> {
            return localVarFp.getProvider(requestParameters.providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list Providers
         * @param {ProvidersApiGetProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviders(requestParameters: ProvidersApiGetProvidersRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetProviders200Response> {
            return localVarFp.getProviders(requestParameters.providerSearchModel, requestParameters.allProviders, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ingest providers from NPIs
         * @param {ProvidersApiIngestProvidersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestProviders(requestParameters: ProvidersApiIngestProvidersRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkProviderPostResponseModel> {
            return localVarFp.ingestProviders(requestParameters.bulkProviderPostModel, options).then((request) => request(axios, basePath));
        },
        /**
         * API to update status of Provider
         * @summary update Provider status
         * @param {ProvidersApiPatchProviderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchProvider(requestParameters: ProvidersApiPatchProviderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchProvider(requestParameters.providerId, requestParameters.providerPatchModel, options).then((request) => request(axios, basePath));
        },
        /**
         * API to add a new Provider
         * @summary add a new Provider
         * @param {ProvidersApiPostProviderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postProvider(requestParameters: ProvidersApiPostProviderRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.postProvider(requestParameters.providerPostModel, options).then((request) => request(axios, basePath));
        },
        /**
         * API to validate the Provider
         * @summary validate Provider
         * @param {ProvidersApiValidateProviderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProvider(requestParameters: ProvidersApiValidateProviderRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.validateProvider(requestParameters.npi, requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * verify NPI and fetch npi details from npi registry api
         * @summary verify npi details
         * @param {ProvidersApiVerifyNpiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyNpi(requestParameters: ProvidersApiVerifyNpiRequest, options?: RawAxiosRequestConfig): AxiosPromise<NpiRegistryData> {
            return localVarFp.verifyNpi(requestParameters.npi, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProvidersApi - interface
 * @export
 * @interface ProvidersApi
 */
export interface ProvidersApiInterface {
    /**
     * API to delete/mark inactive
     * @summary delete a Provider
     * @param {ProvidersApiDeleteProviderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApiInterface
     */
    deleteProvider(requestParameters: ProvidersApiDeleteProviderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * API to get Provider data
     * @summary get Provider
     * @param {ProvidersApiGetProviderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApiInterface
     */
    getProvider(requestParameters: ProvidersApiGetProviderRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProviderExtendedResponseModel>;

    /**
     * 
     * @summary list Providers
     * @param {ProvidersApiGetProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApiInterface
     */
    getProviders(requestParameters: ProvidersApiGetProvidersRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetProviders200Response>;

    /**
     * 
     * @summary ingest providers from NPIs
     * @param {ProvidersApiIngestProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApiInterface
     */
    ingestProviders(requestParameters: ProvidersApiIngestProvidersRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkProviderPostResponseModel>;

    /**
     * API to update status of Provider
     * @summary update Provider status
     * @param {ProvidersApiPatchProviderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApiInterface
     */
    patchProvider(requestParameters: ProvidersApiPatchProviderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * API to add a new Provider
     * @summary add a new Provider
     * @param {ProvidersApiPostProviderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApiInterface
     */
    postProvider(requestParameters: ProvidersApiPostProviderRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

    /**
     * API to validate the Provider
     * @summary validate Provider
     * @param {ProvidersApiValidateProviderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApiInterface
     */
    validateProvider(requestParameters?: ProvidersApiValidateProviderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * verify NPI and fetch npi details from npi registry api
     * @summary verify npi details
     * @param {ProvidersApiVerifyNpiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApiInterface
     */
    verifyNpi(requestParameters: ProvidersApiVerifyNpiRequest, options?: RawAxiosRequestConfig): AxiosPromise<NpiRegistryData>;

}

/**
 * Request parameters for deleteProvider operation in ProvidersApi.
 * @export
 * @interface ProvidersApiDeleteProviderRequest
 */
export interface ProvidersApiDeleteProviderRequest {
    /**
     * 
     * @type {string}
     * @memberof ProvidersApiDeleteProvider
     */
    readonly providerId: string
}

/**
 * Request parameters for getProvider operation in ProvidersApi.
 * @export
 * @interface ProvidersApiGetProviderRequest
 */
export interface ProvidersApiGetProviderRequest {
    /**
     * 
     * @type {string}
     * @memberof ProvidersApiGetProvider
     */
    readonly providerId: string
}

/**
 * Request parameters for getProviders operation in ProvidersApi.
 * @export
 * @interface ProvidersApiGetProvidersRequest
 */
export interface ProvidersApiGetProvidersRequest {
    /**
     * 
     * @type {ProviderSearchModel}
     * @memberof ProvidersApiGetProviders
     */
    readonly providerSearchModel: ProviderSearchModel

    /**
     * 
     * @type {boolean}
     * @memberof ProvidersApiGetProviders
     */
    readonly allProviders?: boolean

    /**
     * 
     * @type {number}
     * @memberof ProvidersApiGetProviders
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof ProvidersApiGetProviders
     */
    readonly pgSize?: number
}

/**
 * Request parameters for ingestProviders operation in ProvidersApi.
 * @export
 * @interface ProvidersApiIngestProvidersRequest
 */
export interface ProvidersApiIngestProvidersRequest {
    /**
     * 
     * @type {BulkProviderPostModel}
     * @memberof ProvidersApiIngestProviders
     */
    readonly bulkProviderPostModel: BulkProviderPostModel
}

/**
 * Request parameters for patchProvider operation in ProvidersApi.
 * @export
 * @interface ProvidersApiPatchProviderRequest
 */
export interface ProvidersApiPatchProviderRequest {
    /**
     * 
     * @type {string}
     * @memberof ProvidersApiPatchProvider
     */
    readonly providerId: string

    /**
     * 
     * @type {ProviderPatchModel}
     * @memberof ProvidersApiPatchProvider
     */
    readonly providerPatchModel: ProviderPatchModel
}

/**
 * Request parameters for postProvider operation in ProvidersApi.
 * @export
 * @interface ProvidersApiPostProviderRequest
 */
export interface ProvidersApiPostProviderRequest {
    /**
     * 
     * @type {ProviderPostModel}
     * @memberof ProvidersApiPostProvider
     */
    readonly providerPostModel: ProviderPostModel
}

/**
 * Request parameters for validateProvider operation in ProvidersApi.
 * @export
 * @interface ProvidersApiValidateProviderRequest
 */
export interface ProvidersApiValidateProviderRequest {
    /**
     * 
     * @type {string}
     * @memberof ProvidersApiValidateProvider
     */
    readonly npi?: string

    /**
     * 
     * @type {string}
     * @memberof ProvidersApiValidateProvider
     */
    readonly name?: string
}

/**
 * Request parameters for verifyNpi operation in ProvidersApi.
 * @export
 * @interface ProvidersApiVerifyNpiRequest
 */
export interface ProvidersApiVerifyNpiRequest {
    /**
     * 
     * @type {string}
     * @memberof ProvidersApiVerifyNpi
     */
    readonly npi: string
}

/**
 * ProvidersApi - object-oriented interface
 * @export
 * @class ProvidersApi
 * @extends {BaseAPI}
 */
export class ProvidersApi extends BaseAPI implements ProvidersApiInterface {
    /**
     * API to delete/mark inactive
     * @summary delete a Provider
     * @param {ProvidersApiDeleteProviderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public deleteProvider(requestParameters: ProvidersApiDeleteProviderRequest, options?: RawAxiosRequestConfig) {
        return ProvidersApiFp(this.configuration).deleteProvider(requestParameters.providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to get Provider data
     * @summary get Provider
     * @param {ProvidersApiGetProviderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public getProvider(requestParameters: ProvidersApiGetProviderRequest, options?: RawAxiosRequestConfig) {
        return ProvidersApiFp(this.configuration).getProvider(requestParameters.providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list Providers
     * @param {ProvidersApiGetProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public getProviders(requestParameters: ProvidersApiGetProvidersRequest, options?: RawAxiosRequestConfig) {
        return ProvidersApiFp(this.configuration).getProviders(requestParameters.providerSearchModel, requestParameters.allProviders, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ingest providers from NPIs
     * @param {ProvidersApiIngestProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public ingestProviders(requestParameters: ProvidersApiIngestProvidersRequest, options?: RawAxiosRequestConfig) {
        return ProvidersApiFp(this.configuration).ingestProviders(requestParameters.bulkProviderPostModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to update status of Provider
     * @summary update Provider status
     * @param {ProvidersApiPatchProviderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public patchProvider(requestParameters: ProvidersApiPatchProviderRequest, options?: RawAxiosRequestConfig) {
        return ProvidersApiFp(this.configuration).patchProvider(requestParameters.providerId, requestParameters.providerPatchModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to add a new Provider
     * @summary add a new Provider
     * @param {ProvidersApiPostProviderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public postProvider(requestParameters: ProvidersApiPostProviderRequest, options?: RawAxiosRequestConfig) {
        return ProvidersApiFp(this.configuration).postProvider(requestParameters.providerPostModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to validate the Provider
     * @summary validate Provider
     * @param {ProvidersApiValidateProviderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public validateProvider(requestParameters: ProvidersApiValidateProviderRequest = {}, options?: RawAxiosRequestConfig) {
        return ProvidersApiFp(this.configuration).validateProvider(requestParameters.npi, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * verify NPI and fetch npi details from npi registry api
     * @summary verify npi details
     * @param {ProvidersApiVerifyNpiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public verifyNpi(requestParameters: ProvidersApiVerifyNpiRequest, options?: RawAxiosRequestConfig) {
        return ProvidersApiFp(this.configuration).verifyNpi(requestParameters.npi, options).then((request) => request(this.axios, this.basePath));
    }
}

